<template>
  <div>
    <portal-target name="dropdown" slim />
    <div class="md:flex md:flex-col">
      <div class="md:h-screen md:flex md:flex-col">
        <div class="md:flex md:flex-shrink-0">
          <div class="bg-inexgray md:flex-shrink-0 md:w-56 px-6 py-4 flex items-center justify-between md:justify-center">
            <inertia-link class="mt-1" href="/">
             <img src="/img/logo2.png" height="50px" width="100px">
            </inertia-link>
            <div class="mt-1 mr-4"></div>
          <svg @click="smallMenu = !smallMenu" placement="bottom-end"  class="fill-white w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
          </div>
          <div class="bg-inexgray  w-full p-4 md:py-0 md:px-12 text-sm md:text-md flex justify-between items-center">
            <div class="mt-1 mr-4"></div>
            <dropdown class="mt-1" placement="bottom-end">
              <div class="flex items-center cursor-pointer select-none group">
                <div style="color: #FFFFFF;" class="font-bold group-hover:text-indigo-600 focus:text-indigo-600 mr-1 whitespace-nowrap">
                 <a href="/login"><span>{{ $page.props.auth.user.first_name }}</span></a>
                </div>
                <icon class="w-5 h-5 group-hover:fill-inexorange fill-white focus:fill-indigo-600" name="cheveron-down" />
              </div>
              <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <inertia-link class="block px-6 py-2 hover:bg-inexorange hover:text-white" :href="route('users.edit', $page.props.auth.user.id)">Mi Perfil</inertia-link>
                <inertia-link v-if="$page.props.auth.user.rol == 'Admin'" class="block px-6 py-2 hover:bg-inexorange hover:text-white" :href="route('users')">Manage Users</inertia-link>
                <inertia-link class="block px-6 py-2 hover:bg-inexorange hover:text-white w-full text-left" :href="route('logout')" method="delete" as="button">Logout</inertia-link>
              </div>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu v-if="$page.props.auth.user.rol == 'Admin' && smallMenu==true" class="md:block" />
          <main-menu-gerente v-if="$page.props.auth.user.rol == 'asesor' && smallMenu==true" class="md:block" />
          <main-menu-student v-if="$page.props.auth.user.rol == 'student' && smallMenu==true" class="md:block" />

          <div  style="background-color: #2D2E2C;" class="md:flex-1 px-4 py-8 md:p-12 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/Menu/MainMenu'
import MainMenuGerente from '@/Shared/Menu/MainMenuGerente'
import MainMenuStudent from '@/Shared/Menu/MainMenuStudent'




import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Logo,
    MainMenu,
    MainMenuGerente,
    MainMenuStudent,

  },
  data() {
    return {
    smallMenu: false,
    }
  },

}
</script>
